var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgNotActive = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.77707 4.34051C5.4501 3.9426 4.86248 3.8851 4.46458 4.21206C4.06667 4.53903 4.00917 5.12665 4.33613 5.52456L16.0271 19.7519C16.354 20.1498 16.9417 20.2073 17.3396 19.8804C17.7375 19.5534 17.795 18.9658 17.468 18.5679L5.77707 4.34051ZM20.1128 8.94414C20.6341 8.94414 21.1057 9.15551 21.4476 9.49654C21.7886 9.83846 22 10.31 22 10.8314V12.9868C22 14.0285 21.1554 14.8731 20.1128 14.8731C20.0675 14.8731 20.0231 14.8713 19.9796 14.8678V16.0827C19.9796 17.0258 19.2354 17.7941 18.3011 17.8314L16.6741 15.9424H18.0142V7.83135H9.68384L7.97425 5.84734H18.2291C19.1963 5.84734 19.9796 6.63064 19.9796 7.59778V8.94947C20.0231 8.94592 20.0675 8.94414 20.1128 8.94414ZM3.98135 7.83135V15.9424H11.984L13.6137 17.8331H3.75133C2.78419 17.8331 2 17.0498 2 16.0827V7.59778C2 6.77629 2.56572 6.08801 3.3286 5.89885L4.99467 7.83135H3.98135Z",
    fill: "#133155"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNotActive, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/notActive.d0923cd8.svg";
export { ForwardRef as ReactComponent };